import React from 'react';
import { NavLink } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import playwrightLogo from '../../assets/images/icons/playwright-logo.svg';
import allureLogo from '../../assets/images/icons/logo-report-sign.svg';
import viewLogIcon from '../../assets/images/icons/view-log-icon2.png';

const name = ({ original }) => {
  const recordName =
    original.name === undefined ? original.executionname : original.name;
  return <span title={recordName}>{recordName}</span>;
};
const status = ({ original }) => {
  const currentStatus = original.overall_status || original.status;

  if (currentStatus) {
    const parsedStatus =
      currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1);

    return (
      <div>
        <span className={`status status-${currentStatus}`}></span>
        {parsedStatus}
      </div>
    );
  }

  return null;
};
const formatDateAndTime = ({ original }) => {
  const date = new Date(original.createddate);

  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
};
const transaction = ({ original }) => {
  const { service, executionid, transactionid } = original;

  if (transactionid) {
    return (
      <NavLink
        to={`/view/${service}/${executionid}?transactionid=${transactionid}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {transactionid}
      </NavLink>
    );
  }

  return transactionid;
};
const execution = ({ original }) => {
  const { executionid, tools } = original;
  if (tools) {
    const url = `/execution/hosting/${executionid}`;
    return (
        <NavLink to={url} target="_blank" rel="noopener noreferrer">
          {executionid}
        </NavLink>
    );
  }

  return executionid;
};

const errorCategory = (row) => {
  const errorCategory = row.original.errorCategory;
  const rowIndex = row.index;

  if (!errorCategory) {
    return null;
  }

  return (
    <>
      <ReactTooltip
        id={`error-category-tooltip-${rowIndex}`}
        place="top"
        effect="solid"
      >
        {`${errorCategory.fullText} (AI generated, may not be 100% correct)`}
      </ReactTooltip>
      <span data-tip data-for={`error-category-tooltip-${rowIndex}`}>
        {errorCategory.abreviation} <i className={errorCategory.icon}></i>
      </span>
    </>
  );
};
const tableDimensions = {
  name: {
    width: 300,
  },
  status: {
    width: 110,
  },
  environment: {
    width: 50,
  },
  executionID: {
    width: 300,
  },
  createddate: {
    width: 150,
  },
  sharedby: {
    width: 250,
  },
};

const columns = {
  name: {
    id: 'name',
    Header: 'Name',
    accessor: 'executionname',
    width: tableDimensions.name.width,
    Cell: name,
    resizable: true,
  },
  status: {
    id: 'status',
    Header: 'Status',
    accessor: 'overall_status',
    width: tableDimensions.status.width,
    Cell: status,
    resizable: true,
  },
  environment: {
    id: 'env',
    Header: 'Env',
    accessor: 'env',
    width: tableDimensions.environment.width,
    resizable: true,
  },
  executionid: {
    id: 'id',
    Header: 'Execution ID',
    accessor: 'executionid',
    Cell: execution,
    width: tableDimensions.executionID.width,
    resizable: true,
  },
  createdtime: {
    id: 'date',
    Header: 'Created time',
    accessor: 'createddate',
    Cell: formatDateAndTime,
    width: tableDimensions.createddate.width,
    resizable: true,
  },
  total: {
    Header: 'Total',
    accessor: 'totalcount',
    className: 'text-center',
    width: 100,
  },
  sharedby: {
    Header: 'SharedBy',
    accessor: 'sharedby',
    width: tableDimensions.sharedby.width,
  },
};

const testcaseColumns = {
  scenario: {
    id: 'name',
    Header: 'Scenario',
    accessor: 'name',
    width: tableDimensions.name.width,
    Cell: name,
  },
  sharedby: {
    width: tableDimensions.sharedby.width,
  },
  status: {
    id: 'status',
    Header: 'Status',
    accessor: 'status',
    width: tableDimensions.status.width,
    Cell: status,
  },
  environment: {
    id: 'env',
    width: tableDimensions.environment.width,
  },
  trasactionid: {
    id: 'id',
    Header: 'Transaction ID',
    accessor: 'transactionid',
    width: tableDimensions.executionID.width,
    Cell: transaction,
  },
  created: {
    id: 'date',
    Header: 'Created time',
    accessor: 'createddate',
    Cell: formatDateAndTime,
    width: tableDimensions.createddate.width,
  },
  errorCategory: {
    id: 'errorCategory',
    Header: 'Error type',
    accessor: 'errorCategory',
    width: 100,
    className: 'text-center',
    Cell: errorCategory,
  },
};

const executionReportColumn = {
  id: 'reports',
  Header: 'Reports',
  accessor: 'reports',
  width: 100,
  Cell: ({ original }) => {
    const {
      tools,
      executionid,
      totalcount,
      isAllureConfigured,
      overall_status,
      status,
    } = original;
    if (tools !== 'playwright') {
      return null;
    }
    if (
      totalcount === '1' ||
      totalcount === 1 ||
      (['failed', 'success'].indexOf(overall_status) === -1 &&
        ['failed', 'success'].indexOf(status) === -1)
    ) {
      return null;
    }
    if (totalcount === 0) {
      return null;
    }
    return (
      <div className="reports-icons">
        {tools === 'playwright' && (
          <a
            href={`/playwright/report/${executionid}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Playwright Report"
          >
            <img src={playwrightLogo} alt="Playwright Report" />
          </a>
        )}
        {isAllureConfigured && (
          <a
            href={`/playwright/report/${executionid}?reportType=allure`}
            target="_blank"
            rel="noopener noreferrer"
            title="Allure Report"
          >
            <img
              style={{ width: '18px', height: '18px' }}
              src={allureLogo}
              alt="Allure Report"
            />
          </a>
        )}
      </div>
    );
  },
};

const transactionReportColumn = {
  id: 'transactionReports',
  Header: 'Reports',
  accessor: 'transactionReports',
  width: 100,
  Cell: ({ original }) => {
    const { tools, executionid, transactionid, isAllureConfigured } = original;

    return (
      <div className="reports-icons">
        {tools === 'playwright' && transactionid && (
          <a
            href={`/playwright/report/${executionid}/${transactionid}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Playwright Transaction Report"
          >
            <img src={playwrightLogo} alt="Playwright Logo" />
          </a>
        )}
        {isAllureConfigured && transactionid && (
          <a
            href={`/playwright/report/${executionid}/${transactionid}?reportType=allure`}
            target="_blank"
            rel="noopener noreferrer"
            title="Allure Transaction Report"
          >
            <img
              style={{ width: '20px', height: '20px' }}
              src={allureLogo}
              alt="Allure Report"
            />
          </a>
        )}
        <a
          href={`https://autodesk.splunkcloud.com/en-US/app/Splunk_App_for_Testing_Hub/testinghub_script_execution_log_clone?form.time.earliest=%40y&form.time.latest=now&form.loglevel=*&form.order=%2B&form.logid=${transactionid}`}
          target="_blank"
          rel="noopener noreferrer"
          title="View Logs"
        >
          <img
            style={{ width: '20px', height: '20px' }}
            src={viewLogIcon}
            alt="View Logs"
          />
        </a>
      </div>
    );
  },
};

const schema = {
  executions: [
    columns.name,
    columns.status,
    columns.environment,
    columns.executionid,
    columns.createdtime,
    // different width for my-report and shared-report tabs
    { ...columns.total, width: 200 },
    executionReportColumn,
  ],
  testCases: [
    testcaseColumns.scenario,
    testcaseColumns.status,
    testcaseColumns.environment,
    testcaseColumns.trasactionid,
    testcaseColumns.created,
    // different width for my-report and shared-report tabs
    { ...testcaseColumns.errorCategory, width: 200 },
    transactionReportColumn,
  ],
  sharedreportExecutions: [
    columns.name,
    columns.sharedby,
    columns.status,
    columns.environment,
    columns.executionid,
    columns.createdtime,
    columns.total,
    executionReportColumn,
  ],
  sharedreportTestcases: [
    testcaseColumns.scenario,
    testcaseColumns.sharedby,
    testcaseColumns.status,
    testcaseColumns.environment,
    testcaseColumns.trasactionid,
    testcaseColumns.created,
    testcaseColumns.errorCategory,
    transactionReportColumn,
  ],
};

export default schema;
